import './chat-patient.scss';

import { PatientItemDataFragment } from '../../data/types/api/graphql';
import { formatDate } from '../../data/utils/date.utils';
import { useFormatters } from '../../data/utils/formatters.utils';
import { Avatar } from '../avatar/avatar/avatar';
import { CustomFormattedMessage } from '../intl/custom-formatted-message';
import { Tag, TagType } from '../tag/tag';
import { CopyText } from '../utils/copy-text/copy-text';

export enum ChatPatientType {
  DEFAULT = 'DEFAULT',
  EXTENDED = 'EXTENDED',
}

type ChatPatientProps = {
  type?: ChatPatientType;
  patient: PatientItemDataFragment | null | undefined;
};

export function ChatPatient({
  type = ChatPatientType.DEFAULT,
  patient,
}: ChatPatientProps) {
  const { getFullName, getBirthDate } = useFormatters();

  return (
    <div className="chat-patient">
      <div className="chat-patient__info">
        <div className="chat-patient__info__avatar">
          <Avatar avatar={patient?.avatar} />
        </div>
        <div className="chat-patient__info__content">
          <h2>
            {patient &&
              (type === ChatPatientType.EXTENDED ? (
                <CopyText text={getFullName(patient)}>
                  {getFullName(patient)}
                </CopyText>
              ) : (
                getFullName(patient)
              ))}

            {!patient && <CustomFormattedMessage id="common.unknown-patient" />}
          </h2>

          {patient && (
            <p className="info">
              <CopyText text={formatDate(patient.birthDate, 'dd-mm-YYYY')}>
                {getBirthDate(patient)}
              </CopyText>
            </p>
          )}
        </div>
      </div>
      <div className="chat-patient__tags">
        {patient && !patient.app && <Tag type={TagType.NOAPP} />}
        {patient && !patient.dutchInsurance && (
          <Tag type={TagType.NOINSURANCE} />
        )}
        {patient?.noShowProtocol && <Tag type={TagType.NOSHOWPROTOCOL} />}
      </div>
    </div>
  );
}
